const anyDefaultConstants = {
  defaultCourseIds: [
    44,
    49,
    50,
    51,
    53,
    55,
    56,
    62,
    82,
    103,
    122,
    124,
    125,
    139,
    159,
    162,
    172,
    174,
    177,
    183,
    185,
    194,
    219,
    223,
    230,
    243,
    257,
    276,
    277,
    279,
    282,
    302,
    320,
    324,
    326,
    328,
    329,
    332,
    336,
    337,
    338,
    344,
    345,
    346,
    349,
    360,
    364,
    373,
    377,
    313,
    237,
    311,
    133,
    140,
    160,
    171,
    196,
    201,
    216,
    228,
    197,
    200,
    213,
    218,
    288,
    327,
    339,
    318,
    316,
    312,
    305,
    304,
    386,
    317,
    38,
    303,
    73
  ],
  defaultRecommendedCourseIds: [62, 171, 172, 56, 174, 337, 122],
  defaultNewCourseIds: [377, 386, 177, 364, 327],
  defaultTopSaleCourseIds: [277, 174, 172, 73, 257, 53, 171],
  defaultSpecialCourseId: {
    388: {
      startDate: 1763586000000, // 20.11.25 00:00:00,
      showForAll: false,
      showNewMain: false,
      showQuiz: true
    },
    385: {
      startDate: 1764943200000, // 05.12.25 17:00:00
      showForAll: true,
      showNewMain: true,
      showQuiz: false
    },
    393: {
      startDate: 0,
      showForAll: true,
      showNewMain: false,
      showQuiz: false
    }
  },
  defaultSpecialCourseIdsInSubscription: {
    388: 306,
    385: 391,
    393: 391
  },
  defaultSpecialCourseIdsBundle: [62, 171, 172, 277],
  defaultSpecialCourseIdForClub: 188,
  defaultSpecialClubId: 1,
  defaultPaywallServiceId: 3012,
  defaultLinkQuiz: 'https://anyclass.com/landings/ff_school_up_lk_quiz',
  defaultLinkBundle: 'https://anyclass.com/ru/landings/ff_school_up_general_new_bundle5',
  defaultLinkClub: 'https://anyclass.com/ru/landings/ff_school_up_general_prokrasotu_club_newsub'
}

export default anyDefaultConstants
